// extracted by mini-css-extract-plugin
module.exports = {"container":"PurpleArea-module--container--22uLu"};